export const INDICES_TYPES = `
    query _ {
        index_field_type_list {
            id
            type_name
        }
    }
`;
